import React from 'react';

const styles = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '10px',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    border: 'none',
    cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
  },
  primary: {
    backgroundColor: '#3b82f6',
    color: '#fff',
    padding: '14px 28px',
    boxShadow: '0 4px 20px rgba(59, 130, 246, 0.3)',
  },
  secondary: {
    backgroundColor: 'transparent',
    color: '#e2e8f0',
    padding: '14px 28px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  small: {
    padding: '10px 20px',
    fontSize: '14px',
  },
  large: {
    padding: '18px 36px',
    fontSize: '18px',
    borderRadius: '12px',
    boxShadow: '0 8px 30px rgba(59, 130, 246, 0.4)',
  },
  arrow: {
    transition: 'transform 0.2s ease',
  },
};

export const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  href,
  onClick,
  showArrow = false,
  type = 'button',
  style = {},
  className = '',
  ...props
}) => {
  const buttonStyle = {
    ...styles.base,
    ...(variant === 'primary' ? styles.primary : styles.secondary),
    ...(size === 'small' ? styles.small : {}),
    ...(size === 'large' ? styles.large : {}),
    ...style,
  };

  const premiumClass = variant === 'primary'
    ? 'btn-premium focus-ring'
    : 'btn-secondary-premium focus-ring';

  const content = (
    <>
      {children}
      {showArrow && <span style={styles.arrow}>→</span>}
    </>
  );

  if (href) {
    return (
      <a href={href} style={buttonStyle} className={`${premiumClass} ${className}`} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} style={buttonStyle} className={`${premiumClass} ${className}`} {...props}>
      {content}
    </button>
  );
};
